/**
* @name: page-layout-set
* @author: weiyong
* @date: 2023-03-31 20:45
* @description：page-layout-set
* @update: 2023-03-31 20:45
*/
<template>
  <div :class="prefixCls" class="themeAttr-item page-layout-set">
    <span class="themeAttr-item-title">{{t('框架设置')}}</span>
    <div class="themeAttr-item-body flex-div">

      <div class="layout-item" @click="selItem(item)"
           :class="item.id===activeKey?'active':''" v-for="item in layoutAry">
        <div class="item-type-sign">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAWRJREFUaEPtWL1qAkEQnoFDNFEwT5AyKeys8iYprEPewC6FlXkDSZsUeZJco4VwkLO0s4oBJRFyMDLiBXJwbrzxTuacbXdn9/s7dm9wPJ6df0WfAyK6BQAPdIwIEV/PvOY9+qPwmYg6OnD/RYmIL/g2fP9RpHxS54gJkEb1Y8xG4NjumQPmgFABi5BQQHG5OSCWULjBrwM37WvhVsWW+6Nwc2AqgWAyhcXyeyeqRr0GratLEfKs5zgJxAt2oSuKAGNIJuTfBI4drRioERAFXVBsDtg3IIgPl55uhPiC4SG9qIQGQBoO5z0gPTjveiOQt8Ku/c0Bl0J5z5sDeSvs2r/8Dqi/yNLeIC5rDz1/um8hc+BAWbII2R+ZMEriCKltbGVt+e0reNZzyv+U2FfJoteXyoEPALjg7gN3mzUMbvtvH5tz9Idhn4C6GoAnMSLgIwZBUFmsvB4B3bETSojMEfCpUY0e1nEWqyQzMrCnAAAAAElFTkSuQmCC"
            alt="自适应">
          <span class="layoutItem-type-sign-cuntermark"></span>
          <span class="layoutItem-type-sign-icon"><check-outlined/></span>
        </div>
        <div class="itme-title-span w100b">{{ item.name }}</div>
      </div>

    </div>

    <div v-if="activeKey==='scaLayout'" style="margin-top: 30px">框架扩展设置</div>

    <div v-if="activeKey==='scaLayout'" class="set-extend flex-div" style="padding: 6px 0;align-items: center;">
      <div style="font-weight:400;">
        菜单样式：
      </div>
      <a-select @change="changeLeftMenuExtendThem" ref="select"
                v-model:value="leftMenuThem"
                style="width: 200px">
        <a-select-option value="default">默认</a-select-option>
        <a-select-option value="blueRaduisThem">蓝色环状</a-select-option>
      </a-select>
    </div>

  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "page-layout-set",
});
</script>

<script lang="ts" setup>
import {Select as ASelect,SelectOption as ASelectOption} from "ant-design-vue";
import {CheckOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {StorageUtils} from 'xmgoing-utils';
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";
import {useI18n} from "vue-i18n";
import {baseHandler} from "@/layouts/default/setting/handler";
import {HandlerEnum} from "@/layouts/default/setting/enum";

const { t } = useI18n();
const {
  getIsHorizontal,
  getCollapsed,
  getSplit,
} = useMenuSetting();

const emits=defineEmits(['setLayout'])
const layoutAry = [
  {id: 'defaultFrameCom', name: t('经典模式')},
  // {id: 'appFrame', name: t('应用模式')},
  {id: 'defaultFrameTop', name: t('头部菜单')},
  {id: 'defaultFrameLevel', name: t('二级菜单')},
  {id: 'scaLayout', name: t('安全科技')},
  {id: 'government', name: t('生产行业')},
  {id: 'military', name: t('门户模式')},
  {id: 'environmental', name: t('绿色环保')},
  {id: 'technology', name: t('白色简约')},
  {id: 'classicBlue', name: t('大海深蓝')},
]

const {prefixCls} = useDesign('page-layout-set');

const activeKey = ref(StorageUtils.getItem("layout")||'defaultFrameCom');
if(unref(activeKey)==='defaultFrame'){
  activeKey.value='defaultFrameCom';
}
const selItem = function (item) {
  activeKey.value = item.id;
  emits('setLayout',item.id);
}

const {
  getMenuExtendTheme
} = useMenuSetting();

const leftMenuThem=ref(getMenuExtendTheme||'default')
const changeLeftMenuExtendThem=function (value){
  baseHandler(HandlerEnum.MENU_EXTEND_THEME, value)
}




</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-page-layout-set';

.vben-index.zh_CN{
  .page-layout-set{
    .layout-item{
      width: 23%;
    }
  }
}
.@{prefix-cls} {
  width: 100%;
  padding: 16px;
  margin-bottom: 10px;
  border-radius: 6px;
  background: #fff;
  font-family: PingFangSC-Semibold, PingFang SC;

  .themeAttr-item-body {
    flex-wrap: wrap;
  }

  .layout-item {
    position: relative;
    cursor: pointer;
    margin-right: 3px;
    width: 31%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;


    &.active {
      .item-type-sign {
        border: 1px solid #ff2121;
      }

      .layoutItem-type-sign-cuntermark {

        border-color: #ff2121 #ff2121 transparent transparent;
      }

      .layoutItem-type-sign-icon {
        color: #fff;
      }
    }

    .layoutItem-type-sign-icon {
      position: absolute;
      top: -1px;
      right: 0.5px;
      width: 20px;
      height: 20px;
      font-size: 9px;
      z-index: 2;
      color: transparent;
      font-weight: bold;
    }

    .layoutItem-type-sign-cuntermark {
      position: absolute;
      top: 0;
      right: 13px;
      width: 16px;
      height: 16px;
      border: 8px solid transparent;
      z-index: 1;
    }
  }

  .themeAttr-item-title {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    margin-bottom: 14px;
  }

  .itme-title-span {
    text-align: center;
    margin-top: 6px;
  }

  .item-type-sign {
    width: 51px;
    height: 51px;
    padding: 3px;
    border: 1px solid #fff;
    border-radius: 3px;

  }
}
</style>
